<template>
  <div>
    <section class="container-fluid p-0">
      <slot />
    </section>
    <!-- <page-footer/> -->
  </div>
</template>
<script>
export default {};
</script>
